import clsx from 'clsx';

type Props = {
  variant: 'xl' | 'large' | 'medium' | 'small' | 'xs' | 'xxs' | 'mobile-xl';
  classes?: string;
  children: React.ReactNode;
};

const Heading = ({ children, classes = 'text-black-50', variant }: Props) => {
  const className = clsx('font-bold', classes);
  switch (variant) {
    case 'xxs':
      return <h6 className={`${className} title-md`}>{children}</h6>;
    case 'xs':
      return <h5 className={`${className} title-lg`}>{children}</h5>;
    case 'small':
      return <h4 className={`${className} headline-md`}>{children}</h4>;
    case 'medium':
      return <h3 className={`${className} headline-md md:headline-lg`}>{children}</h3>;
    case 'large':
      return <h2 className={`${className} display-sm sm:display-md`}>{children}</h2>;
    case 'xl':
      return <h1 className={`${className} display-md sm:display-lg mb-8`}>{children}</h1>;
    case 'mobile-xl':
      return <h1 className={`${className} headline-lg`}>{children}</h1>;
    default:
      return <h2 className={`${className} display-sm sm:display-md md:display-lg`}>{children}</h2>;
  }
};

export default Heading;
